import React, {Component} from 'react';
import styled from 'styled-components';
import FeaturedSection from "../common/FeaturedSection";
import FilterSection from "../filter/FilterSection";
import HomeBlocks from "../home/HomeBlocks";
import HomeWindow from "../home/HomeWindow";
import Translation from "../dictionary/Translation";
import Button from "../common/Button";
import Main from "../layout/Main";
import Nav from "../layout/Nav";
import ScrollToTopOnMount from "../common/ScrollToTopOnMount";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";


class Home extends Component {

    componentWillMount() {
        this.props.requestProducts();
    }

    render() {
        return (
            <React.Fragment>
                <ScrollToTopOnMount/>
                <Nav/>
                <HomeWindow title={<Translation k={'HOME_HEADER'}/>} subtitle={<Translation k={'HOME_SUBHEADER'}/>}
                            actions={<React.Fragment>
                                    <Button fixedMin onClick={() => console.log('click')}
                                            label={<Translation k={'DOWNLOAD_PRICELIST'}/>}/>
                                    <Button to={'/catalog'} fixedMin secondary
                                            label={<Translation k={'VIEW_CATALOG'}/>}/>
                                </React.Fragment>}/>
                <Main>
                    <FeaturedSection/>
                    <FilterSection/>
                    <HomeBlocks/>
                </Main>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestProducts: Actions.requestProducts
    }, dispatch)
}

export default connect(null, mapDispatchToProps)(toJS(Home));